// extracted by mini-css-extract-plugin
export default {"nextPreviousButtons":"NextPrevious_nextPreviousButtons__UCBF2"};